/*
 * guideStream — llama al endpoint SSE público /api/pwa/guide/chat/stream (sin auth).
 * Es sesión-anónima (device_id) para que la Guía Virtual funcione post-QR sin registro.
 */

import { devWarn } from "./devLog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export async function guideStream({
  deviceId,
  message,
  merchantId = null,
  lat = null,
  lng = null,
  reset = false,
  onChunk,
  onDone,
  onError,
  onMerchantPaused,
  signal,
}) {
  try {
    const res = await fetch(`${BACKEND_URL}/api/pwa/guide/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        device_id: deviceId,
        message,
        merchant_id: merchantId,
        lat,
        lng,
        reset,
      }),
      signal,
    });
    if (!res.ok || !res.body) {
      const err = await res.text().catch(() => "network");
      onError?.(err || `HTTP ${res.status}`);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let full = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf("\n\n")) !== -1) {
        const frame = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);
        for (const line of frame.split("\n")) {
          if (!line.startsWith("data:")) continue;
          const payload = line.slice(5).trim();
          if (!payload) continue;
          try {
            const evt = JSON.parse(payload);
            if (evt.type === "chunk") {
              full += evt.text;
              onChunk?.(evt.text);
            } else if (evt.type === "done") {
              onDone?.({ full: evt.full || full });
              return;
            } else if (evt.type === "error") {
              onError?.(evt.detail || "AI error");
              return;
            } else if (evt.type === "merchant_paused") {
              onMerchantPaused?.(evt.merchant_id);
            }
          } catch (parseErr) {
            if (payload.length > 0 && payload[0] === "{") {
              devWarn("[guideStream] malformed frame", payload.slice(0, 80), parseErr?.message);
            }
          }
        }
      }
    }
    onDone?.({ full });
  } catch (e) {
    if (e?.name === "AbortError") return;
    onError?.(e?.message || String(e));
  }
}
